import axios from "axios";
import { KEYS } from "constants/keys";
import { AWS_CHAT_ENDPOINT } from "constants/config";

export const ctbChatService = {
  ask: async (message) => {
    const user = JSON.parse(localStorage.getItem(KEYS.user) || "{}");

    const payload = {
      input: message,
      session_id: String(user.id)
    };

    try {
      const response = await axios.post(AWS_CHAT_ENDPOINT, payload, {
        headers: { "Content-Type": "application/json" }
      });

      return { data: response.data.output || response.data };

    } catch (error) {
      throw error.response?.data?.message || "ctb-chat.messages.errors.ask";
    }
  },

  health: async () => ({ data: { status: "UP" } }),
  active: async () => ({ active: true }),
};
